// @flow
/**
 * Help selectors
 **/
import { createSelector } from "reselect";
import { Map } from "immutable";

const getHelp = (state: Map<string, any>) => {
  return state.get("help");
};

const getRoot = createSelector(getHelp, (help: Map<string, any>) => {
  return help.get("root");
});
const getByKey = createSelector(getHelp, (help: Map<string, any>) => {
  return help.get("by_key");
});
const getUiState = createSelector(getHelp, (help: Map<string, any>) => {
  return help.get("ui_state");
});
const getSelectedTab = createSelector(getUiState, (ui: Map<string, any>) => {
  return ui.get("selectedTab");
});
const getSearch = createSelector(getHelp, (help: Map<string, any>) => {
  return help.get("search_results");
});
const getPageUrl = createSelector(getHelp, (help: Map<string, any>) => {
  return help.get("page").get("url");
});

const isSearching = createSelector(
  getSearch,
  (searchStore: Map<string, any>) => {
    return searchStore.get("loading");
  }
);
const getSearchResults = createSelector(
  getSearch,
  (searchStore: Map<string, any>) => {
    return searchStore.get("results");
  }
);
export {
  getRoot,
  getByKey,
  getSelectedTab,
  isSearching,
  getSearchResults,
  getPageUrl,
};
